// extracted by mini-css-extract-plugin
module.exports = {"localeSwitcherInput":"localeSwitcher_localeSwitcherInput__FAzPf","arcade":"localeSwitcher_arcade__l_b5z"};